import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/about.vue'
import Culture from './views/culture.vue'
import CY from './views/cy.vue'
import ProInfo from './views/proInfo.vue'
import News from './views/news.vue'
import NewsInfo from './views/newsInfo.vue'
import NewsInfo2 from './views/cultureInfo.vue'
import ldInfo from './views/ldInfo.vue'
import Contact from './views/contact.vue'
import Human from './views/human.vue'
import Login from './views/login.vue'
import Apply from './views/Apply.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/ldInfo',
      name: 'ldInfo',
      component: ldInfo
    },
    {
      path: '/apply',
      name: 'Apply',
      component: Apply
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/culture',
      name: 'Culture',
      component: Culture
    },
    {
      path: '/cy',
      name: 'cy',
      component: CY
    },
    {
      path: '/proInfo',
      name: 'ProInfo',
      component: ProInfo
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: '/newsInfo',
      name: 'NewsInfo',
      component: NewsInfo
    },
    {
      path: '/newsInfo2',
      name: 'NewsInfo2',
      component: NewsInfo2
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/human',
      name: 'Human',
      component: Human
    }
  ]
})
